import * as runtime from '@/api/runtime'
import {
  BatchSchoolLendCollectionListRequest,
  BatchSchoolLendCollectionListRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchSchoolLendCollectionListCondition,
  BatchSchoolLendCollectionListConditionFromJSON
} from '@/api/models/batch/BatchSchoolLendCollectionListCondition'

/**
 * 帳票作成
 */
export class BatchSchoolLendCollectionListApi extends runtime.BaseAPI {
  async return(request: BatchSchoolLendCollectionListRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/lend/school-lend-collection-list`,
      BatchSchoolLendCollectionListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchSchoolLendCollectionListCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchSchoolLendCollectionListConditionFromJSON(jsonValue)
    ).value()
  }
}
